import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import MaterialRadioGroup, { RadioGroupProps } from '@material-ui/core/RadioGroup';
import React from 'react';
import { IOption } from '../Select/Select';

export interface IDisableableOption extends IOption {
  disabled?: boolean;
}

interface IProps extends RadioGroupProps {
  options: IDisableableOption[];
}

const RadioGroup = ({ options, ...props }: IProps) => (
  <MaterialRadioGroup {...props} className={`radio-group ${props.className}`}>
    {options.map((option, key) => (
      <FormControlLabel
        classes={{ label: 'radio-item-label', disabled: 'disabled' }}
        className={`radio-item ${props.value === option.value ? 'active' : ''}`}
        control={<Radio className="radio-item-radio" color="primary" />}
        disabled={!!option.disabled}
        key={`radio-item-${key}`}
        label={option.label}
        value={option.value}
      />
    ))}
  </MaterialRadioGroup>
);

export { RadioGroup };
